import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import { loginSchema } from "@/models/login/schema/loginSchema";
import type { LoginSchemaType } from "@/models/login/schema/loginSchema";

export const useValidateLogin = () => {
  return useForm<LoginSchemaType>({
    resolver: zodResolver(loginSchema),
    mode: "all",
  });
};
